import React, {useMemo} from 'react';
import {useForm} from 'react-hook-form';
import {useSearchParams} from 'react-router-dom';
import {t} from '@lingui/core/macro';

import {tariffVariantAPI} from 'features/admin/api/tariffVariantAPI';
import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import Select from 'shared/ui/Select/Select';
import ListFiltersForm from 'shared/ui/Modal/ListFiltersForm/ListFiltersForm';
import {IFiltersFormComponentProps} from 'shared/ui/Modal/ListFiltersModal/ListFiltersModal';

import {
    getTariffVariantPeriodOptions,
    getTariffVariantTariffOptions,
    TARIFF_VARIANT_PERIOD_PARAM,
    TARIFF_VARIANT_TARIFF_PARAM,
} from '../../../lib/tariffVariantFilters';

interface ITariffVariantsFiltersForm {
    tariff?: string,
    period?: string,
}

const TariffVariantsFiltersForm: React.FC<IFiltersFormComponentProps> = ({onClose}) => {
    const [searchParams] = useSearchParams();
    const {data: items = []} = tariffVariantAPI.useGetTariffVariantsQuery(undefined);

    const {handleSubmit, control} = useForm<ITariffVariantsFiltersForm>({
        defaultValues: {
            tariff: searchParams.get(TARIFF_VARIANT_TARIFF_PARAM) ?? undefined,
            period: searchParams.get(TARIFF_VARIANT_PERIOD_PARAM) ?? undefined,
        },
    });

    const tariffOptions = useMemo(() => getTariffVariantTariffOptions(items, t` (арх.)`), [items]);
    const periodOptions = useMemo(() => getTariffVariantPeriodOptions(items), [items]);

    const toFilters = ({tariff, period}: ITariffVariantsFiltersForm) => ({
        [TARIFF_VARIANT_TARIFF_PARAM]: tariff ?? undefined,
        [TARIFF_VARIANT_PERIOD_PARAM]: period ?? undefined,
    });

    return (
        <ListFiltersForm handleSubmit={handleSubmit} toFilters={toFilters} onClose={onClose}>
            <FormGroupWithError label={t`Тариф`}>
                <Select
                    control={control}
                    name="tariff"
                    data={tariffOptions}
                    cleanable={true}
                    searchable={tariffOptions.length > 5}
                />
            </FormGroupWithError>

            <FormGroupWithError label={t`Кол-во дней`}>
                <Select control={control} name="period" data={periodOptions} cleanable={true} searchable={false}/>
            </FormGroupWithError>
        </ListFiltersForm>
    );
};

export default TariffVariantsFiltersForm;
